/**
 * תבניות הודעת הזמנה ל-WhatsApp.
 * {name} · {couple} · {date} · {venue} (כולל כתובת+Waze/Maps) · {link}
 * גם: {address} {waze} {maps}
 */
export const INVITE_TEMPLATES = [
  {
    id: 'classic',
    title: 'קלאסית עם קישור',
    body:
      `💍 *הזמנה לחתונה של {couple}*\n\n` +
      `היי {name}!\n` +
      `נשמח לראותכם באירוע שלנו.\n\n` +
      `📅 {date}\n\n` +
      `{venue}` +
      `\nלאישור הגעה לחצו כאן:\n{link}`,
  },
  {
    id: 'warm',
    title: 'חמה ואישית',
    body:
      `היי {name} 💛\n\n` +
      `אנחנו ({couple}) מתרגשים להזמין אתכם לחתונה שלנו!\n\n` +
      `📅 {date}\n\n` +
      `{venue}` +
      `\nאשרו הגעה בקלות בקישור:\n{link}`,
  },
  {
    id: 'short',
    title: 'קצרה וממוקדת',
    body:
      `*{couple}* מזמינים אתכם! 🎉\n` +
      `{date}\n\n` +
      `{venue}` +
      `\nהיי {name} — לאישור הגעה:\n{link}`,
  },
] as const;

export type InviteTemplateId = (typeof INVITE_TEMPLATES)[number]['id'] | 'custom';

export function fillInviteTemplate(
  templateBody: string,
  vars: { couple: string; date: string; venue: string; link?: string },
): string {
  return templateBody
    .replace(/\{couple\}/g, vars.couple || 'הזוג')
    .replace(/\{date\}/g, vars.date || '')
    .replace(/\{venue\}/g, vars.venue || '')
    .replace(/\{link\}/g, vars.link || 'https://…/i/…')
    // {name} נשאר לשליחה בפועל
    ;
}
